<template>
    <DateTimePicker
        ref="datepicker"
        class="w-full"
        @change="handleInput"
        :value="this.item.response"
        :enableDate="item.params.date"
        :enableTime="item.params.time"
    />
</template>

<script>

    import DateTimePicker from '@/components/DateTimePickerLocal.vue';

    export default {
        components: { DateTimePicker },

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        methods: {
            handleInput(value) {
                this.$store.commit('conduct/changeResponse', {
                    item: this.item.uuid,
                    response: value,
                    responded: value !== null,
                });
            },
        },
    };
</script>
